import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Price } from '@common/components/Price';

export const ITEM_MARGIN = 10;

export const EventsGridWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -${ITEM_MARGIN}px;
`;

interface ImagePlaceholderProps {
  ratio: number;
}

export const ImagePlaceholder = styled.div<ImagePlaceholderProps>`
  height: 0;
  padding-top: ${({ ratio }: any) => ratio * 100}%;
  width: 100%;
  background: ${({ theme }) => theme.customColors.tertiary};

  ${media.md`
    max-width: 345px;
  `}
`;

interface EventProps {
  columns: number;
}

export const Event = styled.div<EventProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 20px ${ITEM_MARGIN}px;

  ${media.md`
    width: calc(100% / ${({ columns }: any) => columns});
  `}

  img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
`;

export const EventName = styled.div`
  min-height: 55px;
  font-size: 18px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  line-height: 22px;
  letter-spacing: 0.36px;
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const PriceLabel = styled.div`
  color: ${({ theme }) => theme.defaultColors.fontSecondary};
`;

export const StyledPrice = styled(Price)`
  font-size: 16px;
  font-weight: ${({ theme }) => theme.fontWeights.semiBold};
  color: ${({ theme }) => theme.defaultColors.fontPrimary};
`;

export const ImageWrapper = styled.div`
  position: relative;
`;
